<script lang="ts">
  import FlyOutTeachMenu from '$lib/teach/FlyOutTeachMenu.svelte';
  import Alerts from '$lib/components/Alerts.svelte';
  import { twMerge } from 'tailwind-merge';
  import { openModal } from '$lib/stores/modals.store';
  let clazz = '';
  export { clazz as class };

  let flyOut1: FlyOutTeachMenu;
  let flyOut2: FlyOutTeachMenu;
  let flyOut3: FlyOutTeachMenu;

  function toggleMenu(evt: Event) {
    if (evt instanceof KeyboardEvent) {
      if (evt.key !== 'Enter' && evt.key !== ' ') return;
    }
    flyOut1.toggle();
    flyOut2.toggle();
    flyOut3.toggle();
    evt.preventDefault();
    evt.stopPropagation();
  }

  function hideAllMenus() {
    flyOut1.set(false);
    flyOut2.set(false);
    flyOut3.set(false);
  }
</script>

<Alerts class="fixed left-0 right-0 bottom-0 top-auto" />
<div class="xs:hidden">
  <FlyOutTeachMenu on:hide={hideAllMenus} bind:this={flyOut1} />
</div>
<div class={twMerge('bg-blue wrapper', clazz)}>
  <header>
    <!-- Navigation: Big Screens -->
    <div class="margins sm:flex py-4 justify-between hidden">
      <div class="flex-initial my-auto">
        <a href="/"
          ><img
            class="inline-block h-10"
            src="/teach/t-landing/logo-utheory-navigation-green.svg"
            alt="uTheory Logo"
            aria-hidden="true"
          /><span class="sr-only">uTheory Homepage</span></a
        >
      </div>
      <div id="nav" class="text-right relative my-auto">
        <a href="/teach" class="text-white font-normal underline text-sm mt-3 pr-4 mr-1 lg:mr-8"
          >Teach ></a
        >
        <a
          href="/app/lessons/"
          class="text-white font-normal underline text-sm mt-3 pr-4 mr-1 lg:mr-8">Try it ></a
        >
        <button
          on:click={() => openModal('login')}
          class="btn-green py-1.5 px-2 mr-4 lg:mr-10 font-normal">Sign In</button
        >
        <button
          style="background: url(/teach/t-landing/icon-hamburger-menu-lines.png) no-repeat left; min-width: 33px; min-height: 28px"
          class="relative"
          on:touchstart={toggleMenu}
          on:mousedown={toggleMenu}
          on:keydown={toggleMenu}
        >
          <span class="sr-only">Show/Hide Navigation Menu</span>&nbsp;
        </button>
        <div class="invisible xs:visible">
          <FlyOutTeachMenu on:hide={hideAllMenus} bind:this={flyOut2} class="absolute" />
        </div>
      </div>
    </div>
    <!-- /Navigation: Big Screens -->

    <!-- /Navigation: Small Screens -->
    <div class="margins block pb-4 sm:hidden">
      <div id="nav" class="flex justify-between relative" style="padding-top: 10px">
        <div class="my-auto">
          <a href="/teach" class="text-white font-medium underline text-2xs xs:text-xs py-3 pr-3"
            >Teach ></a
          >
          <a href="/app/lessons" class="text-white font-medium underline text-2xs xs:text-xs py-3"
            >Try it ></a
          >
        </div>

        <!-- <a
					href="https://utheory.com/?no-redirect=true&modal=register-teacher"
					class="text-white font-semibold underline text-2xs xs:text-xs py-3"
					>Create a Free Teacher Account ></a
				> -->
        <div class="text-right my-auto">
          <button on:click={() => openModal('login')} class="btn-green py-2 text-2xs xs:text-xs"
            >Sign In</button
          >
        </div>
      </div>
      <hr class="mt-3 mb-3" />
      <div class="margins flex">
        <div class="flex-initial">
          <a href="/"
            ><img
              class="inline-block w-24"
              src="/teach/t-landing/logo-utheory-navigation-green.svg"
              alt="uTheory Logo"
              aria-hidden="true"
            /></a
          >
        </div>
        <div id="nav" class="text-right flex-1 relative">
          <button
            style="background: url(/teach/t-landing/icon-hamburger-menu-lines.svg) no-repeat left; min-width: 33px; min-height: 32.56px"
            on:touchstart={toggleMenu}
            on:mousedown={toggleMenu}
            on:keydown={toggleMenu}
          >
            <span class="sr-only">Show/Hide Menu</span>&nbsp;
          </button>
          <div class="invisible xs:visible">
            <FlyOutTeachMenu on:hide={hideAllMenus} bind:this={flyOut3} class="fixed xs:absolute" />
          </div>
        </div>
      </div>
    </div>
  </header>
</div>
